




























import { Component, Prop, Vue } from 'vue-property-decorator';
import users from '@/store/modules/users';
import Config from '@/config';
import Loading from '@/components/Loading.vue';
import UserService from '@/services/UserService';

@Component({
  components: {
    Loading,
  },
})
export default class LoginForm extends Vue {
  private show = true;
  private loading = false;

  private form: any = {
    email: '',
    password: '',
  };

  public async onSubmit(event: any) {
    event.preventDefault();
    try {
      this.loading = true;

      await users.authUser(this.form);

      if (this.$store.state.users.userToken) {
        this.$router.push({ name: 'setup' });
      }
    } catch (err) {
      this.loading = false;
      this.$emit('error', err.message);
    }
  }
}
